/**
 * The longest chat message the backend accepts (STORY-334).
 *
 * Mirrors `CHAT_MESSAGE_MAX_CHARS` in chat-client/backend/models.py. The
 * backend answers a longer one with 422; this side says so before sending,
 * and turns that 422 (or a proxy's 413) into a sentence in the UI language
 * instead of «I apologize, but I encountered an error».
 */
export const CHAT_MESSAGE_MAX_CHARS = 100_000;

/** True for the backend's "content is too long" 422 and for a 413. */
export function isMessageTooLongError(error: unknown): boolean {
  const status = (error as { status?: unknown } | null)?.status;
  const message = (error as { message?: unknown } | null)?.message;
  if (status === 413) return true;
  return status === 422 && typeof message === 'string'
    && /^content:/.test(message) && /at most/i.test(message);
}

/** The user-facing sentence: `{length}` and `{max}` filled in. */
export function messageTooLongText(template: string, length: number): string {
  return template
    .replace('{length}', String(length))
    .replace('{max}', String(CHAT_MESSAGE_MAX_CHARS));
}
